require("@babel/polyfill");
require('intersection-observer');

import './plugins/customFunctions'
import Vue from 'vue'

import './plugins/axios'
import './wpvue'

import VueYoutube from 'vue-youtube'
import VueObserveVisibility from 'vue-observe-visibility'
import App from './App.vue'
import router from './router'
import store from "./store/";
import Meta from 'vue-meta'
import './registerServiceWorker'
//https://github.com/sagalbot/vue-select
//import vSelect from 'vue-select'
//https://www.npmjs.com/package/vue-youtube
import { sync } from 'vuex-router-sync';
import { i18n } from './helpers'

sync(store, router)
Vue.use(VueYoutube)

if(window.jQuery && window.jQuery.event){
	window.jQuery.event.special.touchstart = 
		{
			setup: function( _, ns, handle ){
				if ( ns.includes("noPreventDefault") ){
				this.addEventListener("touchstart", handle, { passive: false });
			}else{
				this.addEventListener("touchstart", handle, { passive: true });
			}
		}
	};
}

	
// Before you create app
Vue.config.devtools = process.env.NODE_ENV === 'development'
Vue.config.productionTip = false
Vue.use(Meta)
Vue.use(VueObserveVisibility)
//Vue.component('v-select', vSelect)

Vue.mixin({
	methods:{
		_(string) {
			return i18n(string)
		},
		cookingDifficulity(level = 1){
			level = Number(level)
			if(level === 1) return 'Lett'
			if(level === 2) return 'Middels'
			if(level === 3) return 'Vanskelig'
		}
	}
})

// Google analitic support
let $blockStatsPageView = false;
if(window.CookieInformation){
	$blockStatsPageView = true;
	if(window.CookieInformation.getConsentGivenFor('cookie_cat_statistic') && 
		window.CookieInformation.getConsentGivenFor('cookie_cat_marketing'))
	{
		$blockStatsPageView = false;
	}
}

if (typeof ga === "function" && !$blockStatsPageView) {
	// eslint-disable-next-line no-undef
	ga('set', 'page', router.currentRoute.path);
	// eslint-disable-next-line no-undef
	ga('send', 'pageview');
	router.afterEach(( to ) => {
	// eslint-disable-next-line no-undef
		ga('set', 'page', to.path);
	// eslint-disable-next-line no-undef
		ga('send', 'pageview');

	});

}else{
	console.log('no ga')
}

router.beforeEach((to, from, next) => {
	if (to && from && to.path === from.path) {
		next();
	} else {
		/* window.scroll({
			top: 0,
			left: 0,
		}); */
	// $('html').find('.show-up').removeClass('show-up');
		setTimeout(() => {
			next(); // delay page swap
		}, 50);
	}
})

const app = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')

// After you create app
if( process.env.NODE_ENV === 'development' && window.__VUE_DEVTOOLS_GLOBAL_HOOK__) window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app.constructor